import { useState, useEffect } from 'react';
import useSearch from '../useSearch';

function useSearchResults({ queryKey, resultKeys, entities, fields }) {
  const [currentResults, setCurrentResults] = useState([]);
  const [allResults, setAllResults] = useState([]);
  const [
    {
      searchedValue,
      loading,
      data: { results, total }
    },
    setParams
  ] = useSearch({ queryKey, resultKeys, entities, fields });

  useEffect(
    () => {
      if (currentResults.length !== results.length) {
        setAllResults([...allResults, ...results]);
        setCurrentResults(results);
      }
    },
    [allResults, currentResults, results]
  );

  const clearList = params => {
    setAllResults([]);
    setParams({ ...params, offset: 0 });
  };

  const setQueryParams = params => {
    params.value !== searchedValue ? clearList(params) : setParams(params);
  };

  return [
    {
      loading,
      results: allResults,
      currentResults,
      newResults: results,
      total
    },
    setQueryParams
  ];
}

export default useSearchResults;
